module.exports = __webpack_public_path__ + "img/1540924662.66e22302.jpg";